import React from 'react';
import { Control, Controller } from 'react-hook-form';

import InputAdornment from '@mui/material/InputAdornment';
import { TextFieldProps } from '@mui/material/TextField';

import { Input } from './Input.style';

interface TextInputProps<T = any> {
  name: string;
  label?: string;
  control?: Control<any>;
  type: React.InputHTMLAttributes<unknown>['type'];
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  onIconClick?: () => void;
  required?: boolean;
}

const UserTextInput: React.FC<TextInputProps & TextFieldProps> = ({
  name,
  control,
  label,
  type,
  startIcon,
  endIcon,
  onIconClick,
  required,
  ...extraProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Input
            error={!!error}
            onChange={onChange}
            value={value || ''}
            InputLabelProps={{
              style: {
                color: error ? 'red' : 'blue',
                fontSize: 15
              },
              shrink: type === 'date' ? true : undefined
            }}
            helperText={error?.message || ''}
            InputProps={{
              startAdornment: startIcon && (
                <InputAdornment onClick={onIconClick} position="start">
                  {startIcon}
                </InputAdornment>
              ),
              endAdornment: endIcon && (
                <InputAdornment onClick={onIconClick} position="end">
                  {endIcon}
                </InputAdornment>
              )
            }}
            label={(label ?? '') + (required ? ' * ' : '')}
            variant="outlined"
            fullWidth
            type={type}
            size="small"
            autoComplete="off"
            {...extraProps}
          />
        );
      }}
    />
  );
};

export default UserTextInput;
